import { ErrorHandler, Injectable, Injector, isDevMode } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggingService } from '../services/logging.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) { }

  handleError(error: Error): void {
    const toastr = this.injector.get(ToastrService);
    const logger = this.injector.get(LoggingService);

    if (isDevMode()) {
      console.error(error);
    }

    toastr.error("Something unexpected happened.");

    logger.logError(error).pipe(
      catchError(this.onLogFailure)
    ).subscribe();
  }

  private onLogFailure(error: any, _caught: Observable<Object>) {
    console.error('[FAILED TO LOG ERROR]: ', error);
    return of(null);
  }

}
